import { ArrowBackIosNew, BlockOutlined } from "@mui/icons-material";
import {
  Box,
  Button,

  Chip,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../admin/MainLayout";
import ClientPreview from "./admin_dash/ClientPreview";
import UserQuotation from "./admin_dash/UserQuotation";
import FastMovingProduct from "./admin_dash/FastMovingProduct";
import ProductSegment from "./admin_dash/ProductSegment";
import G3PriceSegment from "./admin_dash/G3PriceSegment";
import TopCollection from "./admin_dash/TopCollection";
import TodayLogin from "./admin_dash/TodayLogin";
import { Search as SearchIcon, GridOn as ExcelIcon } from "@mui/icons-material";
import OpenGroheBrandQuote from "./admin_dash/OpenGroheBrandQuote";
import OpenASBrandQuote from "./admin_dash/OpenASBrandQuote";
import MultiSelectWithCheckbox from "../utils/MultiSelectWithCheckbox";
import G4PriceSegment from "./admin_dash/G4PriceSegment";
import G5PriceSegment from "./admin_dash/G5PriceSegment";
import RoleSelect from "../utils/RoleSelect";
import DateRangeFilter from "../utils/DateRangeFilter";
import { fetchRegion, fetchState } from "../../redux/slices/clientSlice";
import { useDispatch, useSelector } from "react-redux";
import FilterBar2 from "../admin/admin_dashboard/FilterBar2";
import UserService from "../../Services/UserList";


const FY_MONTH_ORDER = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];

const roleOptions = [
  { label: "IC", value: 2 },
  { label: "BSP", value: 3 },
  { label: "DSP", value: 4 },
  { label: "BD", value: 5 },
  { label: "Sales Enabler", value: 6 },
  { label: "Dealer", value: 7 },
  { label: "Studio", value: 8 },
];

const TablePreview = () => {

  const dispatch = useDispatch();
  const { regionOpt, stateOpt } = useSelector((state) => state.adminOption);
  const [channelOpt, setChannelOpt] = useState([]);
  const { state } = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState("");
  const [roleId, setRoleId] = useState(state.role || []);
  
  const [fromDate, setFromDate] = useState(state.from || null);
  const [toDate, setToDate] = useState(state.to || null);
  const [brand, setBrand] = useState("AS");
  const [selectedRegion, setSelectedRegion] = useState(state.region || []);
  const [selectedState, setSelectedState] = useState(Array.isArray(state.state) ? state.state : state.state ? [state.state] : []);
  const [selectedUserId, setSelectedUserId] = useState(Array.isArray(state?.user) ? state.user.map((u) => u.value) : []);
  const [selectedChannels, setSelectedChannels] = useState(state.channel || []);
  const item = state?.title;
  const from = state?.from;
  const to = state?.to;
  const month = state?.month;
  const year = state?.year;
  const userOptions = state?.userOptions;
  const clientPreviewRef = useRef(null);
  const [placeholderText, setPlaceholderText] = useState("Search ...");
  const handleBrandChange = (event, newValue) => {
    if (newValue !== null) {
      setBrand(newValue);
    }
  };
  const [selectedMonth, setSelectedMonth] = useState(
    Array.isArray(month) ? month : month ? [month] : FY_MONTH_ORDER
  );
  const [selectedYear, setSelectedYear] = useState(
    Array.isArray(year)
      ? year.map(String)
      : year
        ? [String(year)]
        : [String(new Date().getFullYear())]
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [state]);

  const handleBackClick = () => navigate(-1);

  const renderContent = () => {
    switch (item) {
      case "Top Projects by Quotations":
        return (
          <ClientPreview
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      case "Top Users by Quotations":
        return (
          <UserQuotation
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            userOptions={userOptions}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      case "Fast Moving Products":
        return (
          <FastMovingProduct
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            userOptions={userOptions}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      case "Top Product Segments":
        return (
          <ProductSegment
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      case "G3Segment":
        return (
          <G3PriceSegment
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            userOptions={userOptions}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      case "G4Segment":
        return (
          <G4PriceSegment
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            userOptions={userOptions}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      case "G5Segment":
        return (
          <G5PriceSegment
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            userOptions={userOptions}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      case "Brand Usage":
        return brand == "AS" ? (
          <OpenASBrandQuote
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        ) : (
          <OpenGroheBrandQuote
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      case "Top Collection Usage":
        return (
          <TopCollection
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            userOptions={userOptions}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      case "Today Login Users":
        return (
          <TodayLogin
            search={searchTerm}
            role={roleId}
            user={selectedUserId}
            from={fromDate}
            to={toDate}
            month={selectedMonth}
            year={selectedYear}
            ref={clientPreviewRef}
            selectedRegion={selectedRegion}
            selectedState={selectedState}
            selectedChannels={selectedChannels}
          />
        );
      default:
        return <div>No Content Available</div>;
    }
  };

  useEffect(() => {
    switch (item) {
      case "Top Projects by Quotations":
        setPlaceholderText("Search by Client Name, User Name, Email");
        break;
      case "Top Users by Quotations":
        setPlaceholderText("Search by User Name, Email, Phone");
        break;
      case "Fast Moving Products":
        setPlaceholderText("Search by SKU,Brand, Category");
        break;
      case "Top Product Segments":
        setPlaceholderText("Search by Segment Name");
        break;
      case "G3Segment":
        setPlaceholderText("Search by  SKU, Brand, Category, Finish");
        break;
      case "G4Segment":
        setPlaceholderText("Search by  SKU, Brand, Category, Finish");
        break;
      case "G5Segment":
        setPlaceholderText("Search by  SKU, Brand, Category, Finish");
        break;
      case "Brand Usage":
        setPlaceholderText("Search by Quotation ID, Client, Username");
        break;
      case "Top Collection Usage":
        setPlaceholderText("Search by Collection");
        break;
      case "CollectionUsage":
        setPlaceholderText("Search by Product Name, SKU, Category");
        break;
      case "Today Login Users":
        setPlaceholderText("Search by User Name");
        break;
      default:
        setPlaceholderText("Search ...");
    }
  }, [item]);

  const MONTHS_LABELS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const months = FY_MONTH_ORDER.map((m) => ({
    value: m,
    label: MONTHS_LABELS[m - 1],
  }));

  const currentYear = new Date().getFullYear();
  const startYear = 2023;
  const yearCount = currentYear - startYear + 1;

  const years = Array.from({ length: yearCount }, (_, i) => {
    const year = currentYear - i;
    return {
      value: String(year),
      label: `${year}-${year + 1}`,
    };
  });

  const yearOptions = years.map((y) => ({ label: y.label, value: y.value }));
  const formattedUserOptions = (userOptions || []).map((u) => ({
    label: u.label,
    value: u.value,
  }));

  const filterConfigs = item === "Today Login Users"
    ? []
    : [
      {
        id: "role",
        label: "Role",
        options: roleOptions,
        selected: roleOptions.filter((s) => roleId.includes(s.value)),
      },
      {
        id: "user",
        label: "Users",
        options: formattedUserOptions,
        selected: formattedUserOptions.filter((u) => selectedUserId.includes(u.value)),
      },
      {
        id: "channel",
        label: "Channel",
        options: channelOpt,
        selected: channelOpt.filter((c) => selectedChannels.includes(c.value)),
      },
      {
        id: "region",
        label: "Region",
        options: regionOpt,
        selected: regionOpt.filter((s) => selectedRegion.includes(s.value)),
      },
      {
        id: "state",
        label: "State",
        options: stateOpt,
        selected: stateOpt.filter((s) => selectedState.includes(s.value)),
      },
      {
        id: "year",
        label: "Year (FY)",
        options: yearOptions,
        selected: yearOptions.filter((y) => selectedYear.includes(y.value)),
      },
    ];

  const handleFilterChange = (filterId, nextSelected) => {
    switch (filterId) {
      case "role": {
        const roles = nextSelected.map((r) => (typeof r === "object" ? r.value ?? r.id : r));
        setRoleId(roles);
        break;
      }
      case "user": {
        const userIds = nextSelected.map((u) => (typeof u === "object" ? u.value ?? u.id : u));
        setSelectedUserId(userIds);
        break;
      }
      case "region": {
        const regions = nextSelected.map((r) => (typeof r === "object" ? r.value ?? r.id : r));
        setSelectedRegion(regions);
        setSelectedState([]);
        break;
      }
      case "channel": {
        const channels = nextSelected.map((c) => (typeof c === "object" ? c.value ?? c.id : c));
        setSelectedChannels(channels);
        break;
      }
      case "state": {
        const states = nextSelected.map((s) => (typeof s === "object" ? s.value ?? s.id : s));
        setSelectedState(states);
        break;
      }
      case "year": {
        const selectedYears = nextSelected.map((y) => String(typeof y === "object" ? y.value : y));
        setSelectedYear(selectedYears);
        break;
      }
      default:
        break;
    }
  };

  const handleMonthChange = (event) => {
    const value = event.target.value;
    setSelectedMonth(typeof value === "string" ? value.split(",") : value);
  };

  const handleYearChange = (event) => {
    const value = event.target.value;
    setSelectedYear(typeof value === "string" ? value.split(",") : value);
  };

  const handleClearFilters = () => {
    setSelectedUserId([]);
    setSelectedChannels([]);
    setRoleId(state.role || []);
    setFromDate(from || null);
    setToDate(to || null);
    setSelectedMonth(Array.isArray(month) ? month : month ? [month] : FY_MONTH_ORDER);
    setSelectedYear(
      Array.isArray(year)
        ? year.map(String)
        : year
          ? [String(year)]
          : [String(new Date().getFullYear())]
    );
    setSearchTerm("");
    setSelectedRegion([]);
    setSelectedState([]);
  };

  useEffect(() => {
    dispatch(fetchRegion());
    UserService.GetChannels().then(response => {
      if (response && response.data) {
        setChannelOpt(response.data.map(ch => ({
          value: ch.id,
          label: ch.channel_name
        })));
      }
    }).catch(console.error);
  }, []);

  return (
    <MainLayout title={item}>
      <Box
        sx={{
          p: { xs: 1, md: 1 },
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          minHeight: 800,
          mx: "auto",
          // backgroundColor: "#fff",
        }}
      >
        {/* Header Section */}
        <FilterBar2
          filters={filterConfigs}
          onFilterChange={handleFilterChange}
          selectedMonth={item !== "Today Login Users" ? selectedMonth : undefined}
          setSelectedMonth={setSelectedMonth}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchPlaceHolder={placeholderText}
          selectedFromDate={item !== "Today Login Users" ? fromDate : undefined}
          setSelectedFromDate={setFromDate}
          selectedToDate={item !== "Today Login Users" ? toDate : undefined}
          setSelectedToDate={setToDate}
          onClearFilters={handleClearFilters}
          actions={
            <div className="flex items-center gap-2">
              <Tooltip title="Go to previous page" arrow>
                <IconButton
                  onClick={handleBackClick}
                  size="small"
                  sx={{
                    backgroundColor: "#fff",
                    border: "1px solid #cbd5e1",
                    "&:hover": { backgroundColor: "#f8fafc" },
                  }}
                >
                  <ArrowBackIosNew fontSize="small" />
                </IconButton>
              </Tooltip>

              <Button
                variant="contained"
                startIcon={<ExcelIcon />}
                onClick={() => clientPreviewRef.current?.downloadExcel()}
                sx={{
                  height: 32,
                  bgcolor: "#2e7d32",
                  textTransform: "none",
                  borderRadius: 12,
                  fontSize: "12px",
                  px: "14px",
                  "&:hover": { bgcolor: "#1b5e20" },
                }}
              >
                Excel
              </Button>

              {item === "Brand Usage" && (
                <ToggleButtonGroup
                  value={brand}
                  exclusive
                  onChange={handleBrandChange}
                  size="small"
                  sx={{ height: 32 }}
                >
                  <ToggleButton value="AS" sx={{ px: 2, fontSize: "11px" }}>
                    AS
                  </ToggleButton>
                  <ToggleButton value="GROHE" sx={{ px: 2, fontSize: "11px" }}>
                    GROHE
                  </ToggleButton>
                </ToggleButtonGroup>
              )}
            </div>
          }
        />

        {/* Content Section */}
        <Box sx={{ mt: 0 }}>{renderContent()}</Box>
      </Box>
    </MainLayout>
  );
};

export default TablePreview;
